<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $tc('settings.setting',1) }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link slot="item-title" to="/super-admin/dashboard">{{ $t('general.home') }}</router-link></li>
        <li class="breadcrumb-item"><router-link slot="item-title" to="/super-admin/settings/admin-profile">{{ $tc('settings.setting', 2) }}</router-link></li>
      </ol>
    </div>
    <div class="row settings-container">
      <div class="col-lg-3 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in menuItems" :key="index" class="settings-menu-item">
            <router-link :class="['link-color', {'active-setting': hasActiveUrl(menuItem.link)}]" :to="menuItem.link">
              <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t(menuItem.title) }}</span>
            </router-link>
          </li>
        </ol>
      </div>
      <div class="col-lg-9">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      menuItems: [
        {
          link: '/super-admin/settings/admin-profile',
          title: 'settings.menu_title.account_settings',
          icon: 'user',
          iconType: 'far'
        },
        {
          link: '/super-admin/settings/contacts',
          title: 'settings.menu_title.contacts',
          icon: 'address-book',
          iconType: 'far'
        },
        {
          link: '/super-admin/settings/currencies-setting',
          title: 'settings.menu_title.currencies_setting',
          icon: 'money-bill-wave',
          iconType: 'fa'
        },
        {
          link: '/super-admin/settings/document-type-setting',
          title: 'settings.menu_title.document_type_setting',
          icon: 'file',
          iconType: 'fa'
        },
      ]
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue === '/super-admin/settings') {
        this.$router.push('/super-admin/settings/admin-profile')
      }
    }
  },
  created () {
    if (this.$route.path === '/super-admin/settings') {
      this.$router.push('/super-admin/settings/admin-profile')
    }
  },
  methods: {
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    }
  }
}
</script>
